import React from 'react';

import { Spacing } from '@vkontakte/vkui';

import styles from './index.module.css';
import { DescriptionProps } from './types';
import { TextContent } from '../../../components/TextContent';

export const Description: React.FC<DescriptionProps> = ({ temperamentData }) => {
  return (
    <div>
      <TextContent text={temperamentData.description} />
      <Spacing size={32}/>
      <TextContent text={temperamentData.abilities} title='Способности'/>
      <Spacing size={32}/>
      <TextContent text={temperamentData.values} title='Ценности и личностные качества'/>
      <Spacing size={32}/>
      <TextContent text={temperamentData.preferences} title='Предпочитаемые виды деятельности'/>
      <Spacing size={32}/>
      {temperamentData.style &&
        <>
          <TextContent text={temperamentData.style} title='Стиль работы'/>
          <Spacing size={32}/>
        </> 
      }
      <TextContent text={temperamentData.professions} title='Профессии'/>
    </div>
  );
};
